import {FOCUS_ARROW_HIDDEN_TYPE, FOCUS_DISPLAY_TYPE} from "../enums";
import {RadioGroup, RadioItem} from "../../../components/form/RadioGroup";
import React from "react";

const ArrowDisplayRadioGroup = ({preset, setPreset, disabled = false})=>{

  const _selected = preset.arrow === FOCUS_ARROW_HIDDEN_TYPE[0].value



  return (
    <RadioGroup label="Arrow: " className="flex justify-end items-center space-x-2">
      {FOCUS_ARROW_HIDDEN_TYPE
        .map((o, ) => (
          <RadioItem
            key={`${o.value}_display_type`}
            label={o.label}
            radioClassName="w-3 h-3"
            className="text-xs mb-2"
            isChecked={o.value === preset.arrow || (!preset.arrow && o.value === FOCUS_ARROW_HIDDEN_TYPE[0].value)}
            name={o.value}
            value={o.value}
            // disabled={!!showModal?.edit || (isProductType && o === FOCUS_DISPLAY_TYPE[2])}
            disabled={disabled}
            onChanged={() => {
              setPreset({...preset, arrow: o.value});
            }}
          />
        ))}
    </RadioGroup>
  );
}

export default ArrowDisplayRadioGroup;




